import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { runStaticQuery } from '../api/query/run.staticQuery';
// import { run as runActions } from '../store/workspaces/workspaces/run';
import ModulePage from '../pages/module/page.module';
import NotFoundPage from '../pages/notFound/page.notFound';
import ProtectedRoute from './Route.protected';
import request from '../request/request';
import { LoginProvider } from 'src/pages/login/context/Login.context';
import LoginPage from '../pages/login/Page.login';
import { getUserData } from 'src/api/services/user/user.get';
import { toast } from 'src/utils/notification';
import { useDispatch } from 'react-redux';
import { focusTab } from 'src/interactions/events/focusTab';
import store from 'src/store/store';
import { addSharedWorkspace } from 'src/store/workspaces/workspaces/actions';
import { v4 as uuidv4 } from 'uuid';
// import BackendLogDialog from 'src/components/Header/backLogDialog/BackendLogDialog';
// import { LoggerProvider } from 'src/components/Header/backLogDialog/context/context';
// import { getUserData } from 'src/api/services/user/user.get';

const RoutesCustom = () => {
  const shareId = window.location.pathname.split('app/')[1];
  const [isSessionValid, setIsSessionValid] = useState(true);
  const expires = new Date();
  expires.setTime(expires.getTime() + (60 * 1000));
  const dispatch = useDispatch<any>();

  useEffect(() => {
    const fetchWorkspaceData = async () => {
      const { valid } = await request(false, 'GET', 'public/check-session', {});
      setIsSessionValid(valid);

      if (!valid)  return;
      
      const response = await runStaticQuery('workspace', null);
      const onLoadEvent = response?.workspace?.events?.find((event) => event?.type === 'onLoad') ?? null;
      
      if(shareId){
        const resp = await request<any, any>(true, 'GET', `services/share/load/${shareId}`);

        if(!resp?.success)
          return toast.warning(resp?.message);

        setTimeout(async() => {
          const { instances } = store.getState().workspaces;
          await dispatch(addSharedWorkspace({...resp.data, uuid: uuidv4(), isNewTab: true}));
          await focusTab(instances.length);
        }, 1000);
      }

      if (!shareId && onLoadEvent) {
        // await runActions(onLoadEvent.key, null, null);
      }
    };

    fetchWorkspaceData();
  }, [shareId]);

  useEffect(() => {
    const logoutOn2kDialog = async () => {
      if (JSON.parse(localStorage.getItem('2k-dialog'))) {
        await request(true, 'POST', 'public/user/logout');
        localStorage.removeItem('2k-dialog');
      }
    };

    const fetchSessionValidity = async () => {
      const { valid } = await request(false, 'GET', 'public/check-session', {});
      setIsSessionValid(valid);
    };
    logoutOn2kDialog();
    fetchSessionValidity();
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<LoginProvider><LoginPage /></LoginProvider>} />
      <Route path="/" element={<Navigate to='/app' />} />
      {isSessionValid ? <Route path="/app" element={<ProtectedRoute><ModulePage /></ProtectedRoute>} /> : null}
      {isSessionValid ? <Route path="/app/:jwtString" element={<ProtectedRoute><Navigate to='/app' /></ProtectedRoute>} /> : null}
      <Route path="/404" element={<NotFoundPage />} />
    </Routes>
  );
};

const App = () => {

  // const [showLogger, setShowLogger] = useState(false);

  useEffect(() => {
    const onKey = async (e: KeyboardEvent) => {
      if (e.key === 'F12' && e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();

        const user = await getUserData();
        if (user?.data?.user?.admin === true) {
          const key = 'logging';
          const current = sessionStorage.getItem(key) === 'true';
          const next = !current; 

          sessionStorage.setItem(key, String(next));
          next ? toast.success('Logging aktiviert') : toast.warning('Logging deaktiviert');
        }
      }
    };

    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);



  // return (
  //   <LoggerProvider visible>
  //     <BrowserRouter>
  //       <RoutesCustom />
  //     </BrowserRouter>
  //     <BackendLogDialog
  //       visible={showLogger}
  //       onClose={() => setShowLogger(false)}
  //     />
  //   </LoggerProvider>
  // );

  return (
    <BrowserRouter>
      <RoutesCustom />
    </BrowserRouter>
  );
};

export default App;
